import Vue from "vue";
import App from "./App.vue";
import VueGtm from "vue-gtm";
import router from "./router";
import store from "./store";
import Button from "@/components/blocks/Button";
import Tabs from "@/components/blocks/Tabs";
import Tab from "@/components/blocks/Tab";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faBars,
  faTimes,
  faPlusCircle,
  faMinusCircle,
  faSink,
  faUtensils,
  faCouch,
  faBath,
  faBed,
  faShoePrints,
  faLevelUpAlt,
  faGamepad,
  faDumbbell,
  faArchive,
  faLaptop,
  faBox,
  faCar,
  faShapes,
  faCheckCircle,
  faCheck,
  faTimesCircle,
  faSpa,
  faTrash,
  faPen,
  faEye,
  faEyeSlash,
  faWrench,
  faSlidersH,
  faFilePdf
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import i18n from "./i18n";
import vSelect from "vue-select";

Vue.component("one-button", Button);
Vue.component("tabs", Tabs);
Vue.component("tab", Tab);

Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";

library.add(
  faBars,
  faTimes,
  faPlusCircle,
  faMinusCircle,
  faSink,
  faUtensils,
  faCouch,
  faBath,
  faBed,
  faShoePrints,
  faLevelUpAlt,
  faGamepad,
  faDumbbell,
  faArchive,
  faLaptop,
  faBox,
  faCar,
  faShapes,
  faCheckCircle,
  faCheck,
  faTimesCircle,
  faSpa,
  faTrash,
  faPen,
  faEye,
  faEyeSlash,
  faWrench,
  faSlidersH,
  faFilePdf
);
Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.config.productionTip = false;

Vue.use(VueGtm, {
  id: "GTM-NHNPVQW",
  vueRouter: router
});

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
  watch: {
    $route: function() {
      // eslint-disable-next-line no-undef
      if (wisepops) {
        // eslint-disable-next-line no-undef
        wisepops("pageview");
      }
    }
  }
}).$mount("#app");
